import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MemorialAdesaoService, MemorialService } from 'administrativo-lib';
import { FuncaoService, GlobalService, Licitacao, LicitacaoOrgaoAudesp, Login, MemorialAdesao } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { LicitacaoOrgaoAudespService } from '../licitacao/licitacao-orgao-audesp/service/licitacao-orgao-audesp.service';

declare var $: any;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-memorial-adesao',
  templateUrl: './memorial-adesao.component.html',
  styleUrls: ['./memorial-adesao.component.css']
})
export class MemorialAdesaoComponent implements OnInit, OnDestroy, OnChanges {

  @Input() edicao: boolean = true;
  @Input() soVisualizar: boolean = false;
  @Input() entidade: Licitacao;
  @Input() login: Login;
  @Output() salvarAdesaoEvent: EventEmitter<any> = new EventEmitter();

  public itemAtual: MemorialAdesao;
  public orgaoAudespAtual: LicitacaoOrgaoAudesp;
  public apenasCotacoes: boolean = false;
  public mostrarBtnAtualizar: boolean = false;
  public mostrarBtnEfetivar: boolean = false;
  public mostrarBtnJulgar: boolean = false;
  protected unsubscribe: Subject<void> = new Subject();

  public imaskConfig = {
    mask: Number,
    scale: 4,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };
  public imaskConfigMoeda = {
    mask: Number,
    scale: 4,
    // signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected confirmationService: ConfirmationService,
    public funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected memorialService: MemorialService,
    protected memorialAdesaoService: MemorialAdesaoService,
    protected licitacaoOrgaoAudespService: LicitacaoOrgaoAudespService
  ) { }

  public async ngOnInit() {
  }

  public async ngOnChanges(changes: SimpleChanges) {
    if (changes['entidade'] || changes['dataAtualizacao']) {
      setTimeout(() => this.converterPropostas(), 1000);
    }
    if (changes['verificarBotoesProp']) {
      // this.verificarBotoes()
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public carregarPropostas() {
    if (this.orgaoAudespAtual) {
      if (!this.orgaoAudespAtual.itens_adesao) {
        this.orgaoAudespAtual.itens_adesao = [];
      }
      if (!this.apenasCotacoes) {
        const itensIds = this.orgaoAudespAtual.itens_adesao.map((p) => p.memorial.id);
        this.entidade.itens.forEach((item) => {
          if (!itensIds.includes(item.id)) {
            const adesao = new MemorialAdesao();
            adesao.memorial = { ...item };
            delete adesao.memorial.itens_adesao;
            this.orgaoAudespAtual.itens_adesao.push(adesao);
          }
        });
      }
      this.orgaoAudespAtual.itens_adesao.sort((a, b) => { return a.memorial.ordem - b.memorial.ordem });
      this.converterPropostas();
    }
  }

  public alterarProposta(adesao) {
    if (adesao) {
      adesao.editavel = true;
    }
  }

  public confirmar() {
    this.carregarPropostas();
    this.removerItensVazios();
    this.orgaoAudespAtual = undefined;
    this.salvarAdesaoEvent.emit();
    $('#dialogAdesaoCad').modal('hide');
  }

  public removerItensVazios() {
    if (this.entidade?.orgao_audesp_aderente) {
      for (let i = 0; i < this.entidade.orgao_audesp_aderente.length; i++) {
        const orgaoAudespAderente = this.entidade.orgao_audesp_aderente[i];

        if (orgaoAudespAderente.itens_adesao) {
          for (let j = 0; j < orgaoAudespAderente.itens_adesao.length; j++) {
            const proposta = orgaoAudespAderente.itens_adesao[j];

            if (!proposta.quantidade || +proposta.quantidade <= 0) {
              if (proposta.id) {
                this.memorialAdesaoService.remover(proposta.id).pipe(takeUntil(this.unsubscribe))
                  .subscribe((res) => {
                    orgaoAudespAderente.itens_adesao.splice(j, 1);
                    j--;
                  }, (err) => toastr.error(err.error.payload));
              } else {
                orgaoAudespAderente.itens_adesao.splice(j, 1);
                j--;
              }
            }
          }
        }
      }
    }
  }

  public toggleApenasCotacoes() {
    if (this.apenasCotacoes) {
      this.removerItensVazios();
    } else {
      this.carregarPropostas();
    }
  }

  private async converterPropostas() {
    if (this.entidade?.itens && this.entidade?.orgao_audesp_aderente) {
      this.entidade.itens.forEach(async (memorial) => {
        memorial.itens_adesao = [];

        this.entidade.orgao_audesp_aderente.forEach((orgaoAudespAderente) => {
          if (orgaoAudespAderente.itens_adesao) {
            orgaoAudespAderente.itens_adesao
              .filter((p) => p.memorial.ordem === memorial.ordem && +p.quantidade > 0)
              .forEach((p) => {
                const prop = { ...p };
                prop.orgao_audesp_aderente = { ...orgaoAudespAderente };
                delete prop.orgao_audesp_aderente.itens_adesao;
                memorial.itens_adesao.push(prop);
              });
          }
        });

        this.ordenarPropostas(memorial.itens_adesao);

      });
    }
  }

  private async ordenarPropostas(itensAdesao: MemorialAdesao[]) {
    // ordena propostas pela ordenação da situação e por valor, respectivamente
    itensAdesao
      .sort((a, b) => { return a.quantidade - b.quantidade })
  }

}
